import React from "react";
import GenericFormDialog, { Field } from "./GenericFormDialog";
import { createClient } from "../services/ClientsService";
import { getUserId } from "../services/authService";
import { toast } from "react-toastify";
import { countries } from "../assets/utils/countries";

interface AddClientDialogProps {
  open: boolean;
  onClose: () => void;
  onCreated?: (client: any) => void;
  branches?: any[];
  initialBranch?: string | null;
}

const AddClientDialog: React.FC<AddClientDialogProps> = ({
  open,
  onClose,
  onCreated,
  branches = [],
  initialBranch,
}) => {
  const formFields: Field[] = [
    { name: "fullName", label: "Full Name" },
    { name: "email", label: "Email" },
    {
      name: "countryCode",
      label: "Country Code",
      type: "dropdown",
      options: countries.map((c) => ({
        label: `+${c.phone} - ${c.label}`,
        value: `+${c.phone}`,
      })),
      searchable: true,
    },
    { name: "phoneNumber", label: "Phone Number" },
    {
      name: "gender",
      label: "Gender",
      type: "dropdown",
      options: [
        { label: "Male", value: "male" },
        { label: "Female", value: "female" },
      ],
    },
    { name: "dob", label: "Date of Birth", type: "date" },
    {
      name: "branch",
      label: "Branch/Business",
      type: "dropdown",
      options: branches.map((branch) => ({
        label: branch.name || "Unknown Branch",
        value: branch.business_id || branch.id || branch._id,
      })),
      hidden:true
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      options: ["Verified", "Unverified"],
    hidden:true
    },
  ];

  return (
    <GenericFormDialog
      open={open}
      onClose={onClose}
      title="Add Client"
      fields={formFields}
      initialValues={{
        status: "Verified",
        countryCode: "+961",
        branch: initialBranch || (branches[0] && (branches[0].business_id || branches[0].id || branches[0]._id)),
      }}
      onSubmit={async (values) => {
        try {
          const userId = getUserId();
          const payload: any = {
            ...values,
            name: values.fullName,
            business_id: values.branch,
            mobile: values.phoneNumber,
            country_code: values.countryCode,
            active: values.status === "Verified" ? "verified" : "unverified",
            user_id: userId,
            admin_user_id: userId,
          };
          delete payload.fullName;
          delete payload.branch;
          delete payload.phoneNumber;
          delete payload.countryCode;
          delete payload.status;

          const response = await createClient(payload);

          toast.success("Client created successfully!", { position: "top-right" });
          onClose();
          if (onCreated) {
            const createdClient =
              (response && (response.client || response.data || response)) || {};
            onCreated({
              ...createdClient,
              ...payload,
            });
          }
        } catch (error: any) {
          console.error("Error creating client:", error);
          const errorMessage =
            error?.response?.data?.error_description ||
            error?.response?.data?.error ||
            error?.message ||
            "Failed to create client. Please try again.";
          toast.error(errorMessage, { position: "top-right" });
        }
      }}
    />
  );
};

export default AddClientDialog;
